const norm = (s) => s.toLowerCase().replace(/[^a-z0-9 ]/g, " ").replace(/\s+/g, " ").trim();

const within1 = (a, b) => {
  if (Math.abs(a.length - b.length) > 1) return false;
  let i = 0, j = 0, edits = 0;
  while (i < a.length && j < b.length) {
    if (a[i] === b[j]) { i++; j++; continue; }
    if (++edits > 1) return false;
    if (a.length > b.length) i++; else if (b.length > a.length) j++; else { i++; j++; }
  }
  return edits + (a.length - i) + (b.length - j) <= 1;
};

const wordMatch = (q, w) => w.startsWith(q) || (q.length >= 4 && (within1(q, w) || within1(q, w.slice(0, q.length))));

export const matchAreas = (areas, query) => {
  const q = norm(query);
  if (!q) return areas;
  if (/^\d+$/.test(q)) return areas.filter((a) => a.pincode.startsWith(q));
  const terms = q.split(" ");
  return areas.filter((a) => {
    const name = norm(a.name);
    if (name.includes(q)) return true;
    const words = name.split(" ");
    return terms.every((t) => words.some((w) => wordMatch(t, w)));
  });
};
